type LanguageType = {
  Language: "en" | "ar";
  setLanguage: (string) => void;
};

const LookupsStore = (set, _get) =>
  ({
    Language: "en",
    setLanguage: (language: string) => {
      set({ Language: language });
    },
  }) as LanguageType;
export default LookupsStore;
